export enum StructuredDocumentAction {
  View = "VIEW",
  Edit = "EDIT",
  EditSectionTitle = "EDIT_SECTION_TITLE",
  AddSection = "ADD_SECTION",
  AddSubsection = "ADD_SUBSECTION",
  AttachDocumentToSection = "ATTACH_DOCUMENT_TO_SECTION",
  DeleteSection = "DELETE_SECTION",
  ViewHistory = "VIEW_HISTORY",
  Download = "DOWNLOAD",
  AddDocument = "ADD_DOCUMENT",
  RemoveFile = "REMOVE_FILE",
}

export enum StructuredTemplateAction {
  AddSection = "ADD_SECTION",
  EditSectionTitle = "EDIT_SECTION_TITLE",
  DeleteSection = "DELETE_SECTION",
  AddSubsection = "ADD_SUBSECTION",
}

export const DRAG_AND_DROP_DEBOUNCE_WAIT_MS = 1500;

export const SUBSECTION_DEPTH_LIMIT = 6;

export enum StructuredDocumentSearchURLParams {
  Version = "version",
  DocumentId = "documentId",
}
